module.exports = __webpack_public_path__ + "img/graph-pink.836ed48d.png";